<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 48 48">
    <title>{{ title }}</title>
    <g :fill="fill">
      <path d="M45.707,14.6l-12.3-12.3A1,1,0,0,0,32.7,2H15.3a1,1,0,0,0-.707.293L2.293,14.6A1,1,0,0,0,2,15.3V32.7a1,1,0,0,0,.293.707l12.3,12.3A1,1,0,0,0,15.3,46H32.7a1,1,0,0,0,.707-.293l12.3-12.3A1,1,0,0,0,46,32.7V15.3A1,1,0,0,0,45.707,14.6ZM24,38a2,2,0,1,1,2-2A2,2,0,0,1,24,38Zm1.045-7.829H22.994L22,9.487h4.043Z"></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Warning",
  props: {
    title: {
      type: String,
      default: 'Attention',
    },
    size: {
      type: Number,
      default: 48,
    },
    fill: {
      type: String,
      default: 'inherit'
    },
  },
  data() {
    return {}
  },
}
</script>

<style scoped lang="scss">

</style>
